// extracted by mini-css-extract-plugin
export default {"wrap":"LogOutComponent_wrap__8cTdw","logoutIcon":"LogOutComponent_logoutIcon__syqp8","logoutText":"LogOutComponent_logoutText__u-Q41"};